import { IUserHolding } from '../interfaces/businessData';

export const MOCK_HOLDING_LIST: IUserHolding[] = [
  {
    id: 20,
    name: 'Yaneken',
    fullAccess: true,
    companies: [
      {
        id: '58',
        name: 'belsport',
        countryCode: 'cl',
        role: {
          name: 'affinity',
          permissions: ['menu.collaborators.collaborators-detail', 'menu.metrics']
        }
      },
      {
        id: '16',
        name: 'test b2b',
        countryCode: 'br',
        role: {
          name: 'default',
          permissions: ['menu', 'support-form']
        }
      }
    ]
  },
  {
    id: 15,
    name: 'Betterfly',
    fullAccess: true,
    companies: [
      {
        id: '8',
        name: 'betterfly',
        countryCode: 'cl',
        role: {
          name: 'affinity',
          permissions: ['menu.collaborators.collaborators-detail', 'menu.metrics']
        }
      }
    ]
  }
];

export const CHANGE_HOLDING_DATA_MOCK_RESPONSE = {
  data: {
    id: 20,
    name: 'Cambio de nombre',
    image: 'https://upload.wikimedia.org/wikipedia/commons/f/f6/11.10.2015_Samoyed_%28cropped%29.jpg'
  }
};

export const MOCK_COLLABORATORS_TO_ADD = {
  integrationName: 'BambooHR',
  integrationLastSync: '01-01-2025 00:00',
  pendingMembers: [
    {
      email: 'michaelr@efficientoffice.com',
      name: 'Michael',
      lastName: 'Romney',
      location: 'Vancouver, Canada',
      startDate: '2024-04-30T00:00:00Z'
    },
    {
      email: 'michelle@efficientoffice.com',
      name: 'Michelle',
      lastName: 'Hannon',
      location: 'Lindon, Utah',
      startDate: '2023-11-29T00:00:00Z'
    }
  ]
};
